import {COMPANY_BANK_STATEMENTS, SELLER_BANK_ACCOUNT_TRANSFER_TYPE} from '@modifi/plugin-onboarding'

export const SELLER_BANK_ACCOUNT_DOCUMENT_INPUT_FIELD_NAMES: string[] = [COMPANY_BANK_STATEMENTS]

export const FIELD_NAME_TO_PROPERTY_NAME_MAPPING: Record<string, string> = {
  [SELLER_BANK_ACCOUNT_TRANSFER_TYPE]: 'transferMethod',
}
